module.exports = __webpack_public_path__ + "img/ico-in-outline.703e9e73.svg";